// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","white":"button_white__9k51q","black":"button_black__audAw","warning":"button_warning__Mb4HP","small":"button_small__pUcW7"};